import Container from '../container/container'
import UsersPanel from '../usersPanel/usersPanel'
import usePosition from '../../hooks/position.hook'
import Notification from '../notification/notification'
import { useEffect } from 'react'
import { useStatistics } from '../../hooks/statistics.hook'
import { NavLink } from 'react-router-dom'

function Header() {
  const { drop, parserC, printParse, writeNames } = usePosition()
  const {getStat} = useStatistics()

  useEffect(() => {
    window.cleanBase = drop
    window.parserC = parserC
    window.getStat = getStat
    window.printParse = printParse
    window.writeNames = writeNames
  }, [])

  const isProduction = process.env.REACT_APP_IS_PROD === 'true'

  return (
    <>
      <Notification></Notification>
      <Container>
        <div className='pt-[36px] pb-[18px] flex justify-between relative z-50 '>
          <NavLink to={'/'} className='block'>
            <img src='/Logo.png' alt='' />
          </NavLink>
          {!isProduction &&
            <div className={`text-Content/Dark block font-semibold text-Regular(24_30)`}>DEV SERVER</div>
          }
          {/* <Button></Button> */}
          {/* <Button
						onPress={drop}
						name="дроп"
					></Button> */}
          <UsersPanel></UsersPanel>
        </div>
      </Container>
    </>
  )
}

export default Header
